import { CHESS_SVG } from '../../chess-svgs.js';
import { getPieceGuide } from '../../piece-guides.js';
import { XQ_PIECES } from '../core/catalog.js';
import { pieceColorForGame } from '../core/game-adapter.js';
import { queryOne } from '../core/dom.js';

export function renderMoveHistory(notes, {
  historyEl = queryOne('#history'),
  moveCountEl = queryOne('#moveCount')
} = {}) {
  moveCountEl.textContent = `${notes.length} nước`;

  if (!notes.length) {
    historyEl.innerHTML = '<div class="empty-state">Chưa có nước đi.</div>';
    return;
  }

  let html = '';
  for (let i = 0; i < notes.length; i += 2) {
    html += `<div class="move-row"><span class="num">${i / 2 + 1}.</span><span>${notes[i] || ''}</span><span>${notes[i + 1] || ''}</span></div>`;
  }
  historyEl.innerHTML = html;
  historyEl.scrollTop = historyEl.scrollHeight;
}

export function renderCapturedPieces(moves, gameType) {
  const captured = { w: [], b: [] };

  for (const move of moves || []) {
    if (!move?.captured) continue;
    const color = pieceColorForGame(gameType, move.captured);
    if (color) captured[color].push(move.captured);
  }

  const order = { q: 0, r: 1, b: 2, n: 3, h: 3, a: 4, e: 5, c: 6, p: 7, k: 8 };

  for (const side of ['w', 'b']) {
    captured[side].sort((a, b) =>
      (order[a.toLowerCase()] ?? 99) - (order[b.toLowerCase()] ?? 99)
    );

    const container = side === 'w' ? queryOne('#capturedWhite') : queryOne('#capturedBlack');
    container.innerHTML = '';

    if (!captured[side].length) {
      container.innerHTML = '<span class="captured-empty">—</span>';
      continue;
    }

    for (const piece of captured[side]) {
      const icon = document.createElement('span');

      if (gameType === 'chess') {
        icon.className = 'captured-piece';
        icon.innerHTML = CHESS_SVG[piece] || '';
      } else {
        icon.className = `captured-piece xq-piece ${pieceColorForGame(gameType, piece) === 'w' ? 'red' : 'black'}`;
        icon.textContent = XQ_PIECES[piece] || '';
      }

      icon.title = getPieceGuide(gameType, piece)?.name || piece;
      container.appendChild(icon);
    }
  }

  queryOne('#capturedWhiteLabel').textContent = gameType === 'xiangqi' ? 'Đỏ mất' : 'Trắng mất';
  queryOne('#capturedBlackLabel').textContent = 'Đen mất';
  queryOne('#capturedCount').textContent = `${captured.w.length + captured.b.length} quân`;
}
